import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';

import useReportParameters from '../../../../../hooks/providers/useReportParameters';
import BaseModal from '../../../../modal/BaseModal';
import PlannedUpdateForm from '../form/PlannedUpdateForm/PlannedUpdateForm';

const PlannedUpdateModal = () => {
  const {isPlannedUpdateModalOpen: isOpen, setIsPlannedUpdateModalOpen: setIsOpen} = useReportParameters();

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <BaseModal title="Planification automatique" maxWidth="md" onClose={onClose} open={isOpen} sx={{zIndex: 99}}>
      <PlannedUpdateForm onClose={onClose} />
    </BaseModal>
  );
};

export default PlannedUpdateModal;
